export default {
    rule_requied : [
        v => !!v || 'Name is required',
    ],
    rule_13digit : [
        v => (v.length == 0 || (v.length == 13 && /\d{13}/.test(v))) || 'must be 13 digit',
    ],
    rule_idcard : [
        v => (v.length == 0 || (11 - ((13*parseInt(v.charAt(0)))+(12*parseInt(v.charAt(1)))+(11*parseInt(v.charAt(2)))+(10*parseInt(v.charAt(3)))+(9*parseInt(v.charAt(4)))+(8*parseInt(v.charAt(5)))+(7*parseInt(v.charAt(6)))+(6*parseInt(v.charAt(7)))+(5*parseInt(v.charAt(8)))+(4*parseInt(v.charAt(9)))+(3*parseInt(v.charAt(10)))+(2*parseInt(v.charAt(11)))) % 11) % 10 == parseInt(v.charAt(12))) || 'Name must be less than 13 characters',
    ],
    rule_year : [
        v => (v.length == 0 || (v.length == 4 && /\d{4}/.test(v))) || 'must be 4 digit',
    ]
}